export function ProfileImage({ profilePicture }: { profilePicture: string }) {
    return (
        <div className="flex m-4 rounded-full overflow-hidden">
            <img src={profilePicture} onError={(e) => { e.currentTarget.src = `${process.env.PUBLIC_URL}/anonymousUser.png`; }} alt="profile" className="profile-img" />
        </div>
    );
}